// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__FMNIC","footer_container":"Footer_footer_container__KA+DA","p":"Footer_p__Z2aNP"};